module.exports = "images/age.2c6350b8.png";